import React, { useState, useContext, useCallback, useEffect } from 'react';
import axios from 'axios';
import { useSelector, shallowEqual } from 'react-redux';

export const PermissionContext = React.createContext();

export function PermissionProvider({ children }) {
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const [permissions, setPermissions] = useState([]);
  const hasPermission = useCallback(
    (resource, method) => {
      return !!permissions.find(
        x =>
          x.resource.endsWith(resource) &&
          x.method.toLowerCase() === method.toLowerCase()
      );
    },
    [permissions]
  );

  useEffect(() => {
    async function getPermissions() {
      if (user) {
        const { data } = await axios.get(`users/${user.arn}/permissions`);
        setPermissions(data);
      }
    }
    getPermissions();
  }, [user]);

  return (
    <PermissionContext.Provider value={{ hasPermission }}>
      {children}
    </PermissionContext.Provider>
  );
}

export const usePermissions = () => useContext(PermissionContext);
